<template>
    <CompassTooltip :disabled="!shouldDisplayTooltip" :content="tooltipContent" placement="top">
        <CompassLink
            ref="compassLink"
            :label="label"
            type="secondary"
            :link="link"
            target="_blank"
            :size="size"
            class="object-link"
            :data-bot="dataBot"
            @click.stop
        >
            <!-- ICON -->
            <template slot="prefix">
                <div class="object-link-icon__wrapper">
                    <CompassIcon :size="sizeIcon" :icon="icon"></CompassIcon>
                </div>
            </template>
        </CompassLink>
    </CompassTooltip>
</template>

<script>
const SIZE = Object.freeze({
    SMALL: 'small',
    MEDIUM: 'medium',
});
export default {
    props: {
        tooltipContent: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'medium',
            validator: (value) => Object.values(SIZE).includes(value),
        },
        link: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        dataBot: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            shouldDisplayTooltip: false,
        };
    },
    computed: {
        sizeIcon() {
            return this.size === SIZE.MEDIUM ? 'small' : 'extra-small';
        },
    },
    mounted() {
        const compassLinkLabel = this.$refs.compassLink?.$el.querySelector('.compass-link__label');
        let textIsEllipsed = false;
        if (compassLinkLabel) {
            textIsEllipsed = compassLinkLabel.clientWidth < compassLinkLabel.scrollWidth;
        }
        this.shouldDisplayTooltip = !!this.tooltipContent && textIsEllipsed;
    },
};
</script>

<style scoped lang="scss">
.object-link {
    ::v-deep .compass-link__label {
        max-width: 320px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &-icon__wrapper {
        background-color: var(--colors-common-background-subtle);
        border-radius: var(--spacing-0);
        color: var(--colors-common-text-standard-default);
        padding: var(--spacing-0);

        &:has(.compass-icon--extra-small) {
            padding: 2px;
        }
    }

    &:hover {
        .object-link-icon__wrapper {
            background-color: var(--colors-common-background-primary-hover-alt);
            color: var(--colors-common-text-primary-hover);
        }
    }
}
</style>
